<template>
  <v-row class="pa-4">
    <v-col cols="12">
      <!-- ! TOP PART -->
      <DashboardTopCardContent
        :callToActionButtonText="$t('L_learn_more')"
        @callToActionCallback="navigateToBenefits"
      >
        <template #main-content>
          <h2 class="font-weight-bold text-center">
            {{ $t('L_protect_what_matters') }}
          </h2>
          <h4 class="text-h4 text-center font-weight-medium">
            {{ $t('L_get_the_protection') }}
          </h4>
        </template>
      </DashboardTopCardContent>
    </v-col>
    <v-col cols="12">
      <!-- ! BOTTOM PART -->
      <DashboardBottomCardContent
        :showCallToActionButton="showGuidanceCalculatorTab"
        :callToActionButtonText="$t('L_get_guidance')"
        @callToActionCallback="navigateToPolicyGuidance"
      >
        <template #icon>
          <v-img
            class="ma-0"
            :src="moneyShieldIcon"
            alt="money-shield-icon"
            width="65"
            role="presentation"
          />
        </template>
        <template #content>
          <h4 role="heading" aria-level="3" class="ml-6">
            <span class="d-block font-weight-bold">{{ $t('L_how_much_is_enough') }}</span>
            <span class="d-block font-weight-regular">{{
              $t('L_determining_how_much_protection')
            }}</span>
          </h4>
        </template>
      </DashboardBottomCardContent>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { CapacitorFacade } from '@/plugins/capacitorPlugin';
import moneyShieldIcon from '../assets/money-shield-icon.svg';
import DashboardBottomCardContent from '../../DashboardBottomCardContent.vue';
import DashboardTopCardContent from '../../DashboardTopCardContent.vue';
import { RouteNames } from '@/router/routeNames';

const componentOptions: ComponentOptions = {
  name: 'PrePurchaseLifeCard',
  data() {
    return { moneyShieldIcon };
  },
  components: { DashboardBottomCardContent, DashboardTopCardContent },
  computed: {
    showGuidanceCalculatorTab() {
      return !CapacitorFacade.isNativePlatform();
    },
  },
  methods: {
    async navigateToBenefits() {
      await this.$router.push({ name: RouteNames.TERM_LIFE_BENEFITS }); // ({ path: '/benefits' });
    },
    async navigateToPolicyGuidance() {
      await this.$router.push({ name: RouteNames.GUIDANCE_CALCULATOR }); // ({ path: '/policy/guidance' });
    },
  },
};

export default defineComponent(componentOptions);
</script>
